import { init as initSentry, reactRouterV6BrowserTracingIntegration, browserTracingIntegration, wrapCreateBrowserRouter } from '@sentry/react';
import { getCurrentScope } from '@sentry/browser';

const sentryLogger = {
    init(config, reactRouterInstrumentations) {
        if (config.environment !== 'production') {
            return null;
        }
    
        initSentry({
            dsn: 'https://ffa4b3f1f254329df275e6eca2359f4b@o1159603.ingest.us.sentry.io/4508449695006721',
            environment: config.environment || 'staging',
            integrations: [
                browserTracingIntegration({}),
                reactRouterV6BrowserTracingIntegration(reactRouterInstrumentations)
            ],
            beforeSend(event, hint) {
                const isNonErrorException =
                    event.exception.values[0].value.startsWith('Non-Error exception captured') ||
                    hint.originalException?.['message']?.startsWith('Non-Error exception captured');
    
                if (isNonErrorException) {
                    return null;
                }
    
                return event;
            },
            tracesSampleRate: 0.1,
            replaysSessionSampleRate: 0.5,
            replaysOnErrorSampleRate: 1.0
        });

        if (window.crypto?.randomUUID) {
            getCurrentScope(scope => scope.setTag('transaction_id', window.crypto.randomUUID()));
        }
    },

    sentryCreateBrowserRouter(createBrowserRouter) {
        return wrapCreateBrowserRouter(createBrowserRouter);
    }
}

export {
    sentryLogger
}
